/** Staff route ownership, shared by server redirects and browser navigation. */
export type Workspace = 'clinic' | 'admin';
const ADMIN_ROOTS = new Set(['to-review', 'rules', 'releases', 'operations', 'insights', 'plan-changes', 'exercise-images', 'overview', 'review', 'exercise-review', 'plans', 'plan-constitution', 'decisions', 'smart-program', 'exercises', 'fitness-exercises', 'companion', 'traffic-light', 'library', 'conversations', 'visits', 'activity', 'clinic-network', 'clinics', 'storylines', 'help-messages']);
export const isStaffPath = (path: string) => ['/cockpit', '/clinic', '/admin'].some(root => path === root || path.startsWith(`${root}/`));
export function workspaceOf(path: string): Workspace {
  if (path === '/admin' || path.startsWith('/admin/')) return 'admin';
  if (path === '/clinic' || path.startsWith('/clinic/')) return 'clinic';
  return ADMIN_ROOTS.has(path.split('/')[2] ?? '') ? 'admin' : 'clinic';
}
export function staffPath(value: string): string {
  const url = new URL(value, 'https://staff.invalid');
  if (!isStaffPath(url.pathname)) return value;
  if (!url.pathname.startsWith('/cockpit')) return value;
  const tail = url.pathname.slice('/cockpit'.length);
  return `/${workspaceOf(url.pathname)}${tail}${url.search}${url.hash}`;
}
/** Existing page components retain their internal route vocabulary during the move. */
export const cockpitPath = (path: string) => path.replace(/^\/(admin|clinic)(?=\/|$)/, '/cockpit');

const CLINIC_ROOTS = new Set(['today','inbox','calendar','patients','tasks','messages','money','notifications','team','clinic','growth']);
export function knownStaffPage(path: string) {
  const root = cockpitPath(path).split('/')[2] ?? '';
  return !root || ADMIN_ROOTS.has(root) || CLINIC_ROOTS.has(root);
}
